import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { Container, Row, Col, Form, Button, Spinner } from 'react-bootstrap';
import { useToast } from '../../../context/ToastContext';
import logo_white from '../../../assets/images/logo_white.png';
import { apiRecoveryCode,apiRecoveryPass } from '../../../api/api';

const Recovery = () => {
  const { addToast } = useToast();
  const navigate = useNavigate();

  const [loadingCode, setLoadingCode] = useState(false);
  const [loadingPass, setLoadingPass] = useState(false);
  const [emailSent, setEmailSent] = useState(false);
  const [passwordChanged, setPasswordChanged] = useState(false);

  const [recoveryEmail, setRecoveryEmail] = useState('');
  const [recoveryCode, setRecoveryCode] = useState('');
  const [recoveryPass, setRecoveryPass] = useState('');
  const [timeLeft, setTimeLeft] = useState(15 * 60);

  useEffect(() => {
    if (emailSent) {
      const timer = setInterval(() => {
        setTimeLeft(prevTime => {
          if (prevTime <= 1) {
            clearInterval(timer);
            navigate('/sign-in');
            return 0;
          }
          return prevTime - 1;
        });
      }, 1000);

      return () => clearInterval(timer);
    }
  }, [emailSent]);

  const formatTime = (seconds) => {
    const minutes = Math.floor(seconds / 60);
    const remainingSeconds = seconds % 60;
    return `${minutes}:${remainingSeconds < 10 ? '0' : ''}${remainingSeconds}`;
  };

  const handleSendCode = async (e) => {
    e.preventDefault();
    try {
      if (!recoveryEmail || recoveryEmail.indexOf('@') === -1 || recoveryEmail.indexOf('.') === -1) {
        throw new Error('E-mail inválido');
      }

      setLoadingCode(true);
      var response = await apiRecoveryCode(recoveryEmail);
      if (response && response.ok) {
        addToast('E-mail enviado com sucesso! Verifique sua caixa de entrada.');
        setEmailSent(true);
      } else {
        addToast('E-mail inválido');
      }
    } catch (error) {
      addToast('Erro, e-mail inválido');
    } finally {
      setLoadingCode(false);
    }
  };

  const handleSavePassword = async (e) => {
    e.preventDefault();
    try {
      setLoadingPass(true);
      var response = await apiRecoveryPass(recoveryEmail, recoveryCode, recoveryPass);
      if (response && response.message) {
        addToast('Senha alterada!');
        setPasswordChanged(true);
        setTimeout(() => {
          navigate('/sign-in');
        }, 3000);
      } else {
        addToast(response.error || 'Erro ao alterar senha');
      }
    } catch (error) {
      addToast('Erro, e-mail inválido');
    } finally {
      setLoadingPass(false);
    }
  };

  const handleBack = () => {
    navigate('/sign-in');
  };

  return (
    <Container fluid className='app-box-page d-flex flex-column justify-content-center vh-100'>
      <Row>
        <Col md={{ span: 6, offset: 3 }}>
          <Container className='d-flex app-box-container'>
            <Row className='flex-grow-1'>
              <Col md={2} className='d-flex flex-column p-4 app-box-col-left'>
                <img src={logo_white} alt=''/>
              </Col>
              <Col md={10} className='d-flex flex-column p-4 app-box-col-right'>
                <div className='text-muted mb-4 text-uppercase text-center mt-4'>
                  Enviaremos um e-mail com um código de recuperação.
                  <br/>
                  caso não receba em até 5 minutos, Verifique sua caixa de spam.
                  <br/>
                  O código ficará válido por 15 minutos.
                </div>
                <Form>
                  <Form.Group className="mb-3" controlId="formEmail">
                    <Form.Label>Email</Form.Label>
                    <Form.Control 
                      type="email" 
                      name="email"
                      size="sm" 
                      placeholder="nome@exemplo.com"
                      disabled={loadingCode || emailSent}
                      onChange={(e) => setRecoveryEmail(e.target.value)} 
                    />
                  </Form.Group>

                <div className='d-flex justify-content-center'>
                  <Button onClick={handleSendCode} variant="primary" size="sm" className='me-1 w-25' disabled={loadingCode || emailSent}>
                    {loadingCode ? <Spinner as="span" animation="border" size="sm" role="status" aria-hidden="true" /> : 'Enviar Código'}
                  </Button>
                  <Button onClick={handleBack} variant="secondary" size="sm" className='ms-1 w-25' disabled={loadingCode || emailSent}>Voltar</Button>
                </div>

                  <Form.Group className="mb-3" controlId="formCode">
                    <Form.Label>Código</Form.Label>
                    <Form.Control 
                      type="input" 
                      size="sm" 
                      disabled={loadingPass || !emailSent || passwordChanged}
                      onChange={(e) => setRecoveryCode(e.target.value)} 
                    />
                  </Form.Group>

                  <Form.Group className="mb-3" controlId="formPass">
                    <Form.Label>Nova Senha</Form.Label>
                    <Form.Control 
                      type="password" 
                      size="sm" 
                      disabled={loadingPass || !emailSent || passwordChanged}
                      onChange={(e) => setRecoveryPass(e.target.value)} 
                    />
                  </Form.Group>

                </Form>
                <div className='d-flex justify-content-center'>
                  <Button onClick={handleSavePassword} variant="primary" size="sm" className='me-1 w-25' disabled={loadingPass || !emailSent || passwordChanged}>
                    {loadingPass ? <Spinner as="span" animation="border" size="sm" role="status" aria-hidden="true" /> : 'Salvar'}
                  </Button>
                  <Button onClick={handleBack} variant="secondary" size="sm" className='ms-1 w-25' disabled={loadingPass || !emailSent || passwordChanged}>Voltar</Button>
                </div>
                {emailSent && (
                  <div className='text-center mt-3'>
                    <span>O código expira em: {formatTime(timeLeft)}</span>
                  </div>
                )}
              </Col>
            </Row>
          </Container>
        </Col>
      </Row>
      <Row>
        <Col md={{ span: 6, offset: 3 }} className='text-center text-muted' style={{ fontSize: 'small' }}>CPUWEB | https://cpuweb.eastus.cloudapp.azure.com | 2025</Col>
      </Row>
    </Container>
  );
};

export default Recovery;